export default __webpack_public_path__ + "static/media/logoLight.0e974015.webp";